import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const PASSWORD_RESET_ROUTE = '/restablecer-contrasena';
const PANEL_AUTH_ROUTE_SUFFIXES = [
  PASSWORD_RESET_ROUTE,
  '/olvide-contrasena',
  '/confirmar-email',
  '/registro',
  '/login',
];

const normalizePathname = (pathname = '/') => {
  const normalized = `/${String(pathname || '/').replace(/^\/+/, '')}`
    .replace(/\/{2,}/g, '/')
    .replace(/\/+$/, '');
  return normalized || '/';
};

const stripPanelRouteSuffix = (pathname) => {
  let normalized = normalizePathname(pathname);

  if (normalized.endsWith('/index.html')) {
    normalized = normalized.slice(0, -'/index.html'.length) || '/';
  }

  for (const route of PANEL_AUTH_ROUTE_SUFFIXES) {
    if (normalized === route) return '';
    if (normalized.endsWith(route)) {
      const prefix = normalized.slice(0, -route.length);
      return prefix.replace(/\/+$/, '');
    }
  }

  return normalized === '/' ? '' : normalized;
};

const mergeSearchParams = (target, source, { override = false } = {}) => {
  const keys = [...new Set([...source.keys()])];
  keys.forEach((key) => {
    const values = source.getAll(key);
    if (override) target.delete(key);
    if (!override && target.has(key)) return;
    values.forEach((value) => target.append(key, value));
  });
};

const normalizeDirectPasswordResetUrl = () => {
  const pathname = normalizePathname(window.location.pathname);
  const rawFragment = String(window.location.hash || '').replace(/^#+/, '');
  const fragmentQueryIndex = rawFragment.indexOf('?');
  const fragmentPath = (fragmentQueryIndex >= 0
    ? rawFragment.slice(0, fragmentQueryIndex)
    : rawFragment
  )
    .replace(/#+/g, '/')
    .replace(/\/{2,}/g, '/');

  const directResetPath =
    pathname === PASSWORD_RESET_ROUTE || pathname.endsWith(PASSWORD_RESET_ROUTE);
  const hashResetPath =
    fragmentPath === PASSWORD_RESET_ROUTE || fragmentPath.endsWith(PASSWORD_RESET_ROUTE);

  if (!directResetPath && !hashResetPath) return;

  const params = new URLSearchParams(window.location.search);
  if (fragmentQueryIndex >= 0) {
    mergeSearchParams(
      params,
      new URLSearchParams(rawFragment.slice(fragmentQueryIndex + 1)),
      { override: true },
    );
  }

  const basePath = stripPanelRouteSuffix(pathname);
  const query = params.toString();
  const canonicalLocation = `${basePath}/#${PASSWORD_RESET_ROUTE}${query ? `?${query}` : ''}`;
  const currentLocation = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (currentLocation === canonicalLocation) return;

  window.history.replaceState(
    window.history.state,
    '',
    canonicalLocation,
  );
};

normalizeDirectPasswordResetUrl();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
